import { AxiosResponse } from 'axios';
import { IssueCostCondition, IssueCostRuleCopyRequest, IssueCostRuleCopyResult, IssueCostRuleUpsert } from './types';
import { getProviderIssueCostRules } from 'features/salesOrder/services';
import { getProviderList } from 'features/providers/services';
import { IProviderListDTO } from 'features/providers/types';
import { ApiSaleOrderService } from '../../services';

const RULES = '/provider-issue-cost-rules';

export const getCostIssuingRulesList = (): Promise<AxiosResponse<IssueCostCondition[]>> => {
	return getProviderIssueCostRules();
};

export const createCostIssuingRule = (rule: IssueCostRuleUpsert): Promise<AxiosResponse<IssueCostCondition>> =>
	ApiSaleOrderService.post(RULES, rule);

export const updateCostIssuingRule = (
	id: number,
	rule: IssueCostRuleUpsert,
): Promise<AxiosResponse<IssueCostCondition>> => ApiSaleOrderService.put(`${RULES}/${id}`, rule);

export const deleteCostIssuingRule = (id: number): Promise<AxiosResponse<void>> =>
	ApiSaleOrderService.delete(`${RULES}/${id}`);

export const copyCostIssuingRules = (
	request: IssueCostRuleCopyRequest,
): Promise<AxiosResponse<IssueCostRuleCopyResult>> => ApiSaleOrderService.post(`${RULES}/copy`, request);

/** La API devuelve hasta 100 proveedores por página: se piden de a 100 hasta tenerlos todos (hoy son unos 300). */
const PROVIDERS_PAGE_SIZE = 100;
const PROVIDERS_MAX_PAGES = 20;

/** Si falla la primera página, el error sube; si falla una de las siguientes, lo que llegó con `complete: false`. */
export const getAllProviders = async (): Promise<{ providers: IProviderListDTO[]; complete: boolean }> => {
	const all: IProviderListDTO[] = [];
	for (let page = 1; page <= PROVIDERS_MAX_PAGES; page++) {
		let response;
		try {
			response = await getProviderList(page, PROVIDERS_PAGE_SIZE);
		} catch (error) {
			if (page === 1) throw error;
			console.error('Error loading providers page', page, error);
			return { providers: all, complete: false };
		}
		const elements = response.data.elements || [];
		all.push(...elements);
		if (elements.length < PROVIDERS_PAGE_SIZE || all.length >= response.data.total) {
			return { providers: all, complete: true };
		}
	}
	// Se llegó al tope de páginas sin tenerlos todos.
	return { providers: all, complete: false };
};
